import CommissionSelector from './CommissionSelector';
export default CommissionSelector;

//# sourceMappingURL=index.js.map